var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-link',{attrs:{"to":{
            name: 'animalactivitychart',
            params: {
                id: _vm.tracker.id,
            },
        }}},[_c('ListItem',{staticClass:"l-center"},[_c('div',{staticClass:"l-inline l-gap-2 l-center"},[_c('ActivityIcon',{attrs:{"width":"24","height":"24"}}),_c('div',{staticClass:"l-stack"},[_c('div',{staticClass:"l-inline l-center-v"},[_vm._v(" "+_vm._s(_vm.$t('showActivity'))+" ")])])],1),_c('p',[_c('BarChartIcon',{attrs:{"width":20,"height":20,"color":"lightgray"}})],1)])],1),_c('BatteryMeasurementsFragment',_vm._b({},'BatteryMeasurementsFragment',_vm.$props,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }